var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.44 3.776c-2.144 0-3.904 1.44-4.352 3.392h-10.304c-0.48-1.952-2.272-3.392-4.32-3.392-2.464 0-4.48 1.984-4.48 4.448 0 1.696 0.992 3.232 2.464 3.968v4.8c0 6.24 5.344 11.232 11.584 11.232s11.584-4.992 11.584-11.232v-4.8c1.408-0.736 2.368-2.272 2.368-3.968-0.032-2.464-2.048-4.448-4.544-4.448zM10.112 12.96c0-0.672 0.544-1.28 1.28-1.28s1.28 0.576 1.28 1.28c0 0.736-0.544 1.28-1.28 1.28s-1.28-0.544-1.28-1.28zM15.904 26.016c-2.304 0-4.256-2.496-4.256-5.536s1.888-5.568 4.256-5.568c2.4 0 4.288 2.528 4.288 5.568s-1.888 5.536-4.288 5.536zM20.48 14.24c-0.736 0-1.28-0.544-1.28-1.28 0-0.672 0.544-1.28 1.28-1.28 0.672 0 1.28 0.576 1.28 1.28 0 0.736-0.544 1.28-1.28 1.28zM13.728 18.144c-0.384 0-0.736 0.192-0.864 0.512-0.128 0.352-0.064 0.736 0.192 0.96l2.176 2.208c0.384 0.352 0.992 0.352 1.344 0l2.208-2.208c0.224-0.224 0.352-0.608 0.192-0.96-0.128-0.384-0.512-0.512-0.864-0.512h-4.384z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimals);
export default __webpack_public_path__ + "static/media/animals.b2863ae6ae7c592a52bb847385a66d98.svg";
export { ForwardRef as ReactComponent };